export default {"src":"/komodo/_next/static/media/ios.2e100764.svg","height":48,"width":154,"blurWidth":0,"blurHeight":0};